module.exports = "<input type=\"checkbox\" [(ngModel)]=\"params.value\" (change)=\"onCheckBoxClick($event)\">"